import BackDrop from '../BackDrop/BackDrop';
import NavItems from '../NavItems/NavItems';
import classes from './SideDrawer.module.css';
import sideDrawerLogo from '../../assets/images/logo.png';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

const SideDrawer = (props) => {
    return (
        <>
            <BackDrop closeDrawer={props.closeDrawer} showBackDrop={props.openDrawer} />
            <div
                className={classes.SideDrawer}
                style={{
                    maxWidth: props.openDrawer ? '70%' : 0,
                    width: props.openDrawer ? '400px' : 0,
                }}
                onClick={props.closeDrawer}>
                <div className={classes.SideDrawerContent}>
                    <div className={classes.SideDrawerLogo}>
                        <img src={sideDrawerLogo} alt='Red Taxi' />
                    </div>
                    <div>
                        <NavItems />
                        <LanguageSwitcher />
                    </div>
                </div>
            </div>
        </>

    );
}

export default SideDrawer;